module.exports = __webpack_public_path__ + "static/media/piechart-placeholder-text.ef773717.png";